import * as React from "react";
import { ImagesContext } from "../Context";
import { SxProps, TableCell, Theme } from "@mui/material";

interface Props {
  column_name: string;
  column_title: string;
  sortObject: any;
  setSortOrder: Function;
  className?: string;
  sx?: SxProps<Theme>;
  width?: string;
  style?: any;
}

const SortComponent: React.FC<Props> = ({
  column_name,
  column_title,
  sortObject,
  setSortOrder,
  className = "nowrap-header",
  sx = {},
  width = "20%",
  style = {},
}) => {
  const images = React.useContext(ImagesContext);

  return (
    <TableCell
      className={className}
      sx={sx}
      style={{...style, cursor: "pointer" }}
      width={width}
      onClick={() => {
        setSortOrder(
          column_name,
          sortObject.direction == "ascending" ? "descending" : "ascending"
        );
      }}
    >
      <div className="row">
        {column_title}
        {sortObject.field == column_name ? (
          <span className="sortIndicator">
            {sortObject.direction == "ascending" ? (
              <img
                src={images.sort_ascending_src}
                width="10"
                className="sort-icon"
                alt="Sort Asc"
              />
            ) : (
              <img
                src={images.sort_descending_src}
                width="10"
                className="sort-icon"
                alt="Sort Desc"
              />
            )}
          </span>
        ) : (
          <span className="sortIndicator">
            <img
              src={images.sort_plain_src}
              width="10"
              className="sort-icon"
              alt="Sort Asc"
            />
          </span>
        )}
      </div>
    </TableCell>
  );
};

export default SortComponent;